import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=3fbecc36&scoped=true"
import script from "./branch.js?vue&type=script&lang=js&external"
export * from "./branch.js?vue&type=script&lang=js&external"
import style0 from "./branch.vue?vue&type=style&index=0&id=3fbecc36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbecc36",
  null
  
)

export default component.exports